import React from 'react'
import MenuItem from 'widgets/navigation/MenuItem'
import { Translation } from '@morningtrain/react-translations'
import * as Icons from 'ui/icons'
import { Can } from '@morningtrain/react-auth'
import Permissions from 'services/Permissions'
import MenuItems from 'widgets/navigation/MenuItems'
import MenuItemWrapper from 'widgets/navigation/MenuItemWrapper'
import EconomyMenuItems from 'widgets/navigation/partials/EconomyMenuItems'

export default function EmployeeMainNavigationInner () {
  return (
    <MenuItemWrapper>
      <MenuItem
        route='app.dashboard.dashboard' label={<Translation name='dashboard.title'/>}
        svgIcon={<Icons.Dashboard/>} hasStatusBar
      />

      <MenuItems label={<Translation name='shifts.menu_title'/>} svgIcon={<Icons.Shifts/>}>
        <Can permission='app.shifts.planner'>
          <MenuItem
            route='app.shifts.planner'
            label={<Translation name='shifts.planner.title'/>}
          />
        </Can>
        <Can permission='app.shifts.planner' negate>
          <MenuItem
            route='app.shifts.view'
            label={<Translation name='shifts.view.title'/>}
          />
        </Can>
        <MenuItem route='app.vacation.my_requests' label={<Translation name='vacation.my_requests.title'/>}/>
        <MenuItem route='app.shift_exchange.overview' label={<Translation name='shiftexchange.title'/>}/>
        <MenuItem route='app.shifts.entries_manage' label={<Translation name='historicshifts.manage_menu_title'/>}/>
      </MenuItems>

      <MenuItems label='Operations' svgIcon={<Icons.Operations/>}>
        <MenuItem route="app.checklists" label={<Translation name="checklists.title"/>}/>
        <MenuItem route="app.cleaning.summary" label={<Translation name="cleaning.titles.menu"/>}/>
        <Can permission={Permissions.ONBOARDING_CHECKLISTS_MANAGE}>
          <MenuItem route="app.onboarding.overview" label={<Translation name="onboarding.titles.overview"/>}/>
        </Can>
        <Can permission={Permissions.ONBOARDING_CHECKLISTS_MANAGE} negate>
          <MenuItem route='app.onboarding.personal' label={<Translation name='onboarding.titles.overview'/>}/>
        </Can>
        <MenuItem route='app.hr.messages' label={<Translation name='hr.messages.title'/>}/>
        <MenuItem route='app.special_days.calendar' label={<Translation name='special_days.title'/>}/>
      </MenuItems>

      <Can permission={Permissions.INVENTORY_ORDER_ADMIN}>
        <Can permission={Permissions.INVENTORY_MANAGE} negate>
          <MenuItem
            route='app.inventory.order.overview' label={<Translation name='inventory.overview.title' />}
            svgIcon={<Icons.Stock />}
          />
        </Can>
      </Can>

      <Can permission={Permissions.INVENTORY_ORDER_DELIVERY_DESKTOP}>
        <MenuItem route='app.inventory.order.delivery' label={<Translation name='inventory.delivery.title'/>}/>
      </Can>

      <EconomyMenuItems/>

      <MenuItems svgIcon={<Icons.Users/>} label={<Translation name='hr.title'/>}>
        <MenuItem route='app.users.index' label={<Translation name='hr.users.title'/>}/>
        <MenuItem route='app.vacation_requests' label={<Translation name='hr.vacation.title'/>}/>
        <MenuItem route='app.hr.employments' label={<Translation name='hr.employments.title'/>}/>
        <Can permission={Permissions.HR_MANAGE_AMO}>
          <MenuItem route='app.hr.amo' label={<Translation name='hr.amo.title'/>}/>
        </Can>
        <Can permission={Permissions.HR_MANAGE_AMO} negate>
          <MenuItem route='app.hr.view_amo' label={<Translation name='hr.amo.title'/>}/>
        </Can>
        <MenuItem route='app.contracts.mine' label={<Translation name='hr.contracts.titles.my_contracts'/>}/>
      </MenuItems>

      <MenuItem
        route='app.files.employee_files.view'
        label={<Translation name='files.employee_files.titles.view'/>}
        svgIcon={<Icons.Folder/>}
      />

      {/* <Can permission={Permissions.ONBOARDING_CHECKLISTS_MANAGE} negate>
        <MenuItem
          route='app.onboarding.personal'
          label={<Translation name='onboarding.titles.overview'/>}
          svgIcon={<Icons.Shirt/>}
        />
      </Can>
      <Can permission={Permissions.ONBOARDING_CHECKLISTS_MANAGE}>
        <MenuItem
          route='app.onboarding.overview'
          label={<Translation name='onboarding.titles.overview'/>}
          svgIcon={<Icons.Shirt/>}
        />
      </Can>

      <MenuItem route='app.users.index' label={<Translation name='hr.users.title'/>}/>

      <MenuItem route='app.hr.contracts' label={<Translation name='hr.contracts.titles.contracts'/>}/>
      <MenuItem route='app.contracts.mine' label={<Translation name='hr.contracts.titles.my_contracts'/>}/>

      <Can permission='app.hr.amo' negate>
        <MenuItem
          route='app.hr.view_amo'
          label={<Translation name='hr.amo.title'/>}
          svgIcon={<Icons.Heart/>}
        />
      </Can>
      <MenuItem
        route='app.hr.amo'
        label={<Translation name='hr.amo.title'/>}
        svgIcon={<Icons.Heart/>}
      />

      <MenuItem route='app.hr.messages' label={<Translation name='hr.messages.title'/>}/>

      <MenuItem route='app.hr.employments' label={<Translation name='hr.employments.title'/>}/>
      <MenuItem route='app.vacation_requests' label={<Translation name='hr.vacation.title'/>}/>

      <MenuItem route='app.economy.index'/>

      <Can permission={Permissions.INVENTORY_ORDER_ADMIN}>
        <MenuItem
          svgIcon={<Icons.Stock/>}
          route='app.inventory.order.overview'
          label={<Translation name='inventory.overview.title'/>}
        />
      </Can>

      <MenuItem
        route='app.files.employee_files.view' label={<Translation name='files.employee_files.titles.view'/>}
        svgIcon={<Icons.Folder/>}
      />

      <MenuItem
        route='app.settings.departments.index'
        label={<Translation name='settings.departments.index.title'/>}
      />
      <MenuItem
        route='app.settings.department_suppliers.index'
        label={<Translation name='settings.department_suppliers.titles.index'/>}
      />
      <MenuItem route='app.settings.permissions' label={<Translation name='settings.permissions.title'/>}/>
      <MenuItem
        route='app.settings.employment_types.index'
        label={<Translation name='settings.employment_types.titles.index'/>}
      />

      <MenuItem route='app.special_days.calendar' label={<Translation name='special_days.title'/>}/>

      <Can permission='app.shifts.entries_manage' negate>
        <MenuItem route='app.shifts.entries' label={<Translation name='historicshifts.view_menu_title'/>}/>
      </Can>
      <MenuItem route='app.shifts.entries_manage' label={<Translation name='historicshifts.manage_menu_title'/>}/> */}

    </MenuItemWrapper>
  )
}
